export async function buscarCep(cep) {
  const limpo = (cep || "").replace(/\D/g, "");
  if (limpo.length !== 8) return null;
  try {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), 5000);
    const r = await fetch(`https://viacep.com.br/ws/${limpo}/json/`, { signal: ctrl.signal });
    clearTimeout(timer);
    const d = await r.json();
    if (d.erro) return null;
    return {
      rua: d.logradouro || "",
      bairro: d.bairro || "",
      cidade: d.localidade || "",
      estado: d.uf || "",
    };
  } catch {
    return null;
  }
}
